export default __webpack_public_path__ + "static/media/ke.7a93d3a6.svg";